import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { TokenService } from './token.service';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  httpOptions!: any;
  httpOptionsV2!: any;
  httpOptionsV3!: any;
  apiUrlV2 = environment.modaAPI;
  sellerAuthorization: any;

  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService,
    private router: Router,
  ) {
  }

  initSellerAuthorization(): void {
    const raw = localStorage.getItem('sellerCode');
    this.sellerAuthorization = raw ? JSON.parse(raw) : null;
  }

  getCurrentPathname(): string {
    return this.router.url;
  }

  getCurrentSellerAuthorization(): boolean {
    this.initSellerAuthorization()
    if (this.sellerAuthorization) {
      this.setHeader();
    }

    const pathname = this.getCurrentPathname();
    return pathname === '/home/salers' && this.sellerAuthorization ? true : false
  }


  setHeader() {
    this.httpOptionsV2 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.tokenService.getToken()
      })
    };
    this.httpOptionsV3 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.sellerAuthorization?.token?.access_token || ''
      })
    };

  }

  // Api V2
  // Módulo de Vendas:
  public postHourSale(datemin: string, datemax: string, branchs: any, sellers: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objPostSaleHour = {}
    operationsList === ''
      ? objPostSaleHour = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers
      }
      : objPostSaleHour = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers,
        'operations': operationsList
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/hours/search', objPostSaleHour, this.httpOptionsV2);
  }

  public postCustomerFinancialBalance(customerCodeList: string, branchs: any): Observable<any> {
    let objCustomerFinancialBalance = {
      "filter": {
        "customerCodeList": [customerCodeList]
      },
      "option": {
        "branchCodeList": branchs,
        "isLimit": true,
        "isOpenInvoice": true,
      },
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'accounts-receivable/v2/customer-financial-balance/search', objCustomerFinancialBalance, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postTotals(datemin: string, datemax: string, branchs: any, sellers: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objPostSaleTotal = {}
    operationsList === ''
      ? objPostSaleTotal = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers
      }
      : objPostSaleTotal = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers,
        'operations': operationsList
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/totals/search', objPostSaleTotal, this.httpOptionsV2);
  }

  public postDocumentType(datemin: string, datemax: string, branchs: any, sellers: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objDocumentType = {}
    operationsList === ''
      ? objDocumentType = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers
      }
      : objDocumentType = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers,
        'operations': operationsList
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/document-types/search', objDocumentType, this.httpOptionsV2);
  }

  public postSellers(datemin: string, datemax: string, branchs: any, sellers: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objSellers = {}
    operationsList === ''
      ? objSellers = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers
      }
      : objSellers = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers,
        'operations': operationsList
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/sellers/search', objSellers, this.httpOptionsV2);
  }

  public postWeekdays(datemin: string, datemax: string, branchs: any, sellers: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objWeekdays = {}
    operationsList === ''
      ? objWeekdays = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers
      }
      : objWeekdays = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers,
        'operations': operationsList
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/weekdays/search', objWeekdays, this.httpOptionsV2);
  }

  public getClassificationTypes(): Observable<any> {
    return this.httpClient.get<any>(this.apiUrlV2 + 'sale-panel/v2/product-classification-types', this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public getBranchList(): Observable<any> {
    return this.httpClient.get<any>(this.apiUrlV2 + 'person/v2/branchesList', this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public getPersonStatistics(customerCode: any, branchCodes: any[]): Observable<any> {
    const branchQuery = branchCodes.map(code => `BranchCode=${code}`).join('&');
    const url = `${this.apiUrlV2}person/v2/person-statistics?CustomerCode=${customerCode}&${branchQuery}`;
    return this.httpClient.get<any>(url, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public getPoolBranches(branchCodes: any[]): Observable<any> {
    const branchQuery = branchCodes.map(code => `branchCode=${code}`).join('&');
    const url = `${this.apiUrlV2}management/v2/pool-branches?${branchQuery}`;
    return this.httpClient.get<any>(url, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postClassificationProduct(datemin: string, datemax: string, branchs: any, sellers: any, classification: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objClassificationTypes = {}
    operationsList === ''
      ? objClassificationTypes = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers,
        'classification_type_code': classification
      }
      : objClassificationTypes = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers,
        'operations': operationsList,
        'classification_type_code': classification
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/product-classifications/search', objClassificationTypes, this.httpOptionsV2);
  }

  public postBranchRanking(datemin: string, datemax: string, branchs: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objBranchRanking = {}
    operationsList === ''
      ? objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs
      }
      : objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'operations': operationsList
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/branch-ranking/search', objBranchRanking, this.httpOptionsV2);
  }

  public postTotalBranchType(datemin: string, datemax: string, branchs: any, sellers: any, classification: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objTotalBranchType = {}
    operationsList === ''
      ? objTotalBranchType = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers,
        'ClassificationTypeCode': classification
      }
      : objTotalBranchType = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': sellers,
        'operations': operationsList,
        'ClassificationTypeCode': classification,
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/totals-branch-type/search', objTotalBranchType, this.httpOptionsV2);
  }

  public postTotalBranch(datemin: string, datemax: string, branchs: any, selers: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objTotalBranch = {}
    operationsList === ''
      ? objTotalBranch = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': selers
      }
      : objTotalBranch = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': selers,
        'operations': operationsList
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/totals-branch/search', objTotalBranch, this.httpOptionsV2);
  }

  public postTotalSeller(datemin: string, datemax: string, branchs: any, selers: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objTotalSaller = {}
    operationsList === ''
      ? objTotalSaller = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': selers
      }
      : objTotalSaller = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'sellers': selers,
        'operations': operationsList
      }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/totals-seller/search', objTotalSaller, this.httpOptionsV2);
  }

  public getAuthorizationSeller(sellerCode: number): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrlV2}authorization/v2/mop-seller-token`, { "sellerCode": sellerCode }, this.httpOptionsV2);
  }


  public getParam(paramName: string): Observable<any> {
    return this.httpClient.get<any>(this.apiUrlV2 + 'management/v2/global-parameter?ParameterCodeList=' + paramName, this.httpOptionsV2);
  }

  // Módulo Financeiro:
  public postAverageTerm(datemin: string, datemax: string, branchs: any): Observable<any> {
    let objAverageTerm = {
      'datemin': datemin,
      'datemax': datemax,
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/average-receipt-period/search', objAverageTerm, this.httpOptionsV2);
  }

  public postAmountReceivable(branchs: any): Observable<any> {
    let objAmountReceivable = {
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/total-receivable/search', objAmountReceivable, this.httpOptionsV2);
  }

  public postAmountReceivedByDocument(datemin: string, datemax: string, branchs: any): Observable<any> {
    let objAmountReceivedByDocument = {
      'datemin': datemin,
      'datemax': datemax,
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/amount-received-document/search', objAmountReceivedByDocument, this.httpOptionsV2);
  }

  public postOverdueCards(branchs: any): Observable<any> {
    let objOverdueCards = {
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/overdue-cards/search', objOverdueCards, this.httpOptionsV2);
  }

  public postOpenAmountByDocument(branchs: any): Observable<any> {
    let objOpenAmountByDocument = {
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/open-amount-document/search', objOpenAmountByDocument, this.httpOptionsV2);
  }

  public postAveragePaymentTerm(datemin: string, datemax: string, branchs: any): Observable<any> {
    let objAveragePaymentTerm = {
      'datemin': datemin,
      'datemax': datemax,
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/average-payment-period/search', objAveragePaymentTerm, this.httpOptionsV2);
  }

  public postTotalAmountPayable(branchs: any): Observable<any> {
    let objTotalAmountPayable = {
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/total-payable/search', objTotalAmountPayable, this.httpOptionsV2);
  }

  public postBiWeekly(branchs: any): Observable<any> {
    let objBiWeekly = {
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/biweekly/search', objBiWeekly, this.httpOptionsV2);
  }

  public postAccountBalance(datemax: string, branchs: any): Observable<any> {
    let objAccountBalance = {
      'datemax': datemax,
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/account-balance/search', objAccountBalance, this.httpOptionsV2);
  }

  public postSupplierTopDebtors(branchs: any): Observable<any> {
    let objTopDebtors = {
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/ranking-supplier-debtors/search', objTopDebtors, this.httpOptionsV2);
  }

  public postSupplierTopBiggest(branchs: any, datemin: string, datemax: string): Observable<any> {
    let objTopBiggest = {
      'branchs': branchs,
      'datemin': datemin,
      'datemax': datemax
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/ranking-supplier-biggers/search', objTopBiggest, this.httpOptionsV2);
  }

  public postCustomerTopDebtors(branchs: any): Observable<any> {
    let objTopDebtors = {
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/ranking-customer-debtors/search', objTopDebtors, this.httpOptionsV2);
  }

  public postCustomerTopBiggest(datemin: string, datemax: string, branchs: any): Observable<any> {
    let objTopBiggest = {
      'datemin': datemin,
      'datemax': datemax,
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/ranking-customer-biggers/search', objTopBiggest, this.httpOptionsV2);
  }

  public postFinancialResult(datemin: string, datemax: string, branchs: any, result_type: number): Observable<any> {
    let objFinancialResult = {
      'datemin': datemin,
      'datemax': datemax,
      'branchs': branchs,
      'result_type': result_type
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'financial-panel/v2/financial-income-statement/search', objFinancialResult, this.httpOptionsV2);
  }

  public getIsSeller(httpItem: any): Observable<any> {
    return this.httpClient.get<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/seller-code', httpItem);
  }

  public getBranchSeller(): Observable<any> {
    return this.httpClient.get<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/seller/branchesList', this.httpOptionsV2);
  }

  public postSellersList(branchs: any): Observable<any> {
    let objPostSellersList = {
      'branchs': branchs
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'sale-panel/v2/sellers-list/search', objPostSellersList, this.httpOptionsV2);
  }

  public postTotalSellerPanel(datemin: string, datemax: string, branchs: any): Observable<any> {


    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objBranchRanking = {}
    operationsList === ''
      ? objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs
      }
      : objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'operations': operationsList
      }

    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'datemin': this.sellerAuthorization?.filter?.dataMin,
        'datemax': this.sellerAuthorization?.filter?.dataMax,
        'branchs': this.sellerAuthorization?.filter?.branch.map((row: any) => Number(row)),
      }
    }

    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/totals/search', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postSalesReturnsSellerPanel(datemin: string, datemax: string, branchs: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objBranchRanking = {}
    operationsList === ''
      ? objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs
      }
      : objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'operations': operationsList
      }

    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'datemin': this.sellerAuthorization?.filter?.dataMin,
        'datemax': this.sellerAuthorization?.filter?.dataMax,
        'branchs': this.sellerAuthorization?.filter?.branch.map((row: any) => Number(row)),
      }
    }


    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/sales-vs-returns/search', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postConditionalRateSellerPanel(branchs: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objBranchRanking = {}
    operationsList === ''
      ? objBranchRanking = {
        'branchs': branchs
      }
      : objBranchRanking = {
        'branchs': branchs,
        'operations': operationsList
      }


    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'branchs': this.sellerAuthorization?.filter?.branch.map((row: any) => Number(row)),
      }
    }

    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/seller/conditional-rate', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postWeekdaysSellerPanel(datemin: string, datemax: string, branchs: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objBranchRanking = {}
    operationsList === ''
      ? objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs
      }
      : objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'operations': operationsList
      }

    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'datemin': this.sellerAuthorization?.filter?.dataMin,
        'datemax': this.sellerAuthorization?.filter?.dataMax,
        'branchs': this.sellerAuthorization?.filter?.branch.map((row: any) => Number(row)),
      }
    }

    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/weekdays/search', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postPendingConditionalsSellerPanel(branchs: any): Observable<any> {
    let objBranchRanking = {
      'branchs': branchs
    }

    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'branchs': this.sellerAuthorization?.filter?.branch.map((row: any) => Number(row)),
      }
    }

    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/seller/pending-conditionals', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postCustomerPurchasedProducts(customerCode: number, startDate: string, endDate: string, branchCodes: string[] | null = null): Observable<any> {
    var branches = this.getCurrentSellerAuthorization() 
    ? this.sellerAuthorization?.filter?.branch.map((row: any) => Number(row)) 
    : branchCodes;
    
    let payload = {
      'startDate': startDate,
      'endDate': endDate,
      'customerCode': customerCode,
      'branchCodes': branches,
      'page':1,
      'pageSize':100
    };

    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/seller/customer-purchased-products', 
      payload,this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postTopCustomersSellerPanel(datemin: string, datemax: string, branchs: any, orderByQuantity: boolean): Observable<any> {
    let objBranchRanking = {
      'datemin': datemin,
      'datemax': datemax,
      'branchs': branchs,
      'orderByQuantity': orderByQuantity,
      'returnItensQuantity': 20,
    }

    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'datemin': this.sellerAuthorization?.filter?.dataMin,
        'datemax': this.sellerAuthorization?.filter?.dataMax,
        'branchs': this.sellerAuthorization?.filter?.branch.map((row: any) => Number(row)),
        'orderByQuantity': true,
        'returnItensQuantity': 20,
      }
    }

    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/seller/top-customers', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postBirthdaySellerPanel(datemin: string, datemax: string): Observable<any> {
    let objBranchRanking = {
      'datemin': datemin,
      'datemax': datemax
    }

    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'datemin': this.sellerAuthorization?.filter?.dataMin,
        'datemax': this.sellerAuthorization?.filter?.dataMax
      }
    }


    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/seller/period-birthday', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postDayCountSellerPanel(branchs: any, status: boolean): Observable<any> {
    let objBranchRanking = {
      'branchs': branchs,
      'hasPurchasedRecently': status,
      'purchasePeriodInDays': 90,
      'returnItemsQuantity': 90
    }

    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'branchs': this.sellerAuthorization?.filter?.branch.map((row: any) => Number(row)),
        'hasPurchasedRecently': true,
        'purchasePeriodInDays': 90,
        'returnItemsQuantity': 90
      }
    }

    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/seller/day-count-customers', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postMoreSaleProductsSellerPanel(datemin: string, datemax: string, branchs: any, classification: any): Observable<any> {
    let operationsList = '';
    localStorage.getItem('operations') !== ''
      ? operationsList = JSON.parse(localStorage.getItem('operations')!)
      : operationsList = ''
    let objBranchRanking = {}
    operationsList === ''
      ? objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'classification_type_code': classification
      }
      : objBranchRanking = {
        'datemin': datemin,
        'datemax': datemax,
        'branchs': branchs,
        'classification_type_code': classification,
        'operations': operationsList
      }

    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'datemin': this.sellerAuthorization?.filter?.dataMin,
        'datemax': this.sellerAuthorization?.filter?.dataMax,
        'branchs': this.sellerAuthorization?.filter?.branch.map((row: any) => Number(row)),
        'classification_type_code': 0
      }
    }

    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/product-classification/search', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  public postTargetSellerPanel(datemin: string, datemax: string, branch: any): Observable<any> {
    let objBranchRanking = {
      'datemin': datemin,
      'datemax': datemax,
      'branch': branch[0]
    }
    if (this.getCurrentSellerAuthorization()) {
      objBranchRanking = {
        'datemin': this.sellerAuthorization?.filter?.dataMin,
        'datemax': this.sellerAuthorization?.filter?.dataMax,
        'branch': Number(this.sellerAuthorization?.filter?.branch[0]),
      }
    }

    return this.httpClient.post<any>(this.apiUrlV2 + 'analytics/v2/seller-panel/sales-target/search', objBranchRanking, this.getCurrentSellerAuthorization() ? this.httpOptionsV3 : this.httpOptionsV2);
  }

  //Módulo Industrial
  public getTypeClassification(): Observable<any> {
    return this.httpClient.get<any>(this.apiUrlV2 + 'product/v2/classificationType?IsGroup=FALSE', this.httpOptionsV2);
  }

  public getFinalyOrderClassDayNormal(datemin: string, datemax: string, typeClassification: number, typeProduct: number[], branchCode: number[]): Observable<any> {
    let objFinalyClassDay = {
      'datemin': datemin,
      'datemax': datemax,
      'typeClassificationProduct': typeClassification,
      'typeProductList': typeProduct,
      'branches': branchCode
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'manufacturing/v2/normal-finalization/search', objFinalyClassDay, this.httpOptionsV2);
  }

  public getOrderClassDefectInformation(datemin: string, datemax: string, typeClassification: number, typeProduct: number[], branchCode: number[]): Observable<any> {
    let objFinalyClassDay = {
      'datemin': datemin,
      'datemax': datemax,
      'typeClassificationProduct': typeClassification,
      'typeProductList': typeProduct,
      'branches': branchCode
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'manufacturing/v2/defect-finalization/search', objFinalyClassDay, this.httpOptionsV2);
  }

  public getFinalyOrder15Days(typeProduct: number[], branchCode: number[]): Observable<any> {
    let obj = {
      'typeProductList': typeProduct,
      'branches': branchCode
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'manufacturing/v2/fifteenDays-finalization/search', obj, this.httpOptionsV2);
  }

  public getClassificationLocationList(): Observable<any> {
    return this.httpClient.get<any>(this.apiUrlV2 + 'production/v2/classification-type?FinalityTypeList=L&isActive=true', this.httpOptionsV2);
  }

  public getQuantityOrderClassLocation(typeClassificationLocation: number, branchCode: number[]): Observable<any> {
    let objClassLocation = {
      'typeClassificationLocation': typeClassificationLocation,
      'branches': branchCode
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'manufacturing/v2/quantity-location/search', objClassLocation, this.httpOptionsV2);
  }

  public getQuantityOrderClassLocationPart(typeClassificationLocation: number, branchCode: number[]): Observable<any> {
    let objClassLocationPart = {
      'typeClassificationLocation': typeClassificationLocation,
      'branches': branchCode
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'manufacturing/v2/quantity-part-location/search', objClassLocationPart, this.httpOptionsV2);
  }

  public getOrderThroughputPlaceInformation(datemin: string, datemax: string, typeClassificationLocation: number, typeProduct: number[], branchCode: number[]): Observable<any> {
    let objOrderMov = {
      'datemin': datemin,
      'datemax': datemax,
      'typeClassificationLocation': typeClassificationLocation,
      'typeProductList': typeProduct,
      'branches': branchCode
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'manufacturing/v2/throughput-movement-place/search', objOrderMov, this.httpOptionsV2);
  }

  public getDefectPanelInformation(typeProductList: number[], branchCode: number[], period: string): Observable<any> {
    let objFinalyClassDay = {
      'typeProductList': typeProductList,
      'branches': branchCode,
      'period': period
    }
    return this.httpClient.post<any>(this.apiUrlV2 + 'manufacturing/v2/defect-panel/search', objFinalyClassDay, this.httpOptionsV2);
  }
}
